 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import KINGOFAIRFIGHTERS_FRONTCOVER from '@/components/KingofAirfighters_frontcover'
 import LOVE_1 from '@/components/love_1'
 import KINGOFAIRFIGHTERS_TITLE from '@/components/KingofAirfighters_title'
 import KINGOFAIRFIGHTERS_COPYRIGHT from '@/components/KingofAirfighters_copyright'
 import KINGOFAIRFIGHTERS_TOC from '@/components/KingofAirfighters_toc'
 import KINGOFAIRFIGHTERS_ILLUSTRATION from '@/components/KingofAirfighters_illustration'
 import KINGOFAIRFIGHTERS_DEDICATION from '@/components/KingofAirfighters_dedication'
 import KINGOFAIRFIGHTERS_PREFACE from '@/components/KingofAirfighters_preface'
 import KINGOFAIRFIGHTERS_INTRODUCTION from '@/components/KingofAirfighters_introduction'
 import KINGOFAIRFIGHTERS_PART1 from '@/components/KingofAirfighters_part1'
 import KINGOFAIRFIGHTERS_PART101 from '@/components/KingofAirfighters_part101'
 import KINGOFAIRFIGHTERS_PART2 from '@/components/KingofAirfighters_part2'
 import KINGOFAIRFIGHTERS_PART201 from '@/components/KingofAirfighters_part201'
 import KINGOFAIRFIGHTERS_PART3 from '@/components/KingofAirfighters_part3'
 import KINGOFAIRFIGHTERS_PART301 from '@/components/KingofAirfighters_part301'
 import KINGOFAIRFIGHTERS_PART302 from '@/components/KingofAirfighters_part302'
 import KINGOFAIRFIGHTERS_PART303 from '@/components/KingofAirfighters_part303'
 import KINGOFAIRFIGHTERS_PART304 from '@/components/KingofAirfighters_part304'
 import KINGOFAIRFIGHTERS_PART305 from '@/components/KingofAirfighters_part305'
 import KINGOFAIRFIGHTERS_PART306 from '@/components/KingofAirfighters_part306'
 import KINGOFAIRFIGHTERS_PART307 from '@/components/KingofAirfighters_part307'
 import KINGOFAIRFIGHTERS_PART308 from '@/components/KingofAirfighters_part308'
 import KINGOFAIRFIGHTERS_PART309 from '@/components/KingofAirfighters_part309'
 import KINGOFAIRFIGHTERS_PART310 from '@/components/KingofAirfighters_part310'
 import KINGOFAIRFIGHTERS_PART311 from '@/components/KingofAirfighters_part311'
 import KINGOFAIRFIGHTERS_PART312 from '@/components/KingofAirfighters_part312'
 import KINGOFAIRFIGHTERS_PART4 from '@/components/KingofAirfighters_part4'
 import KINGOFAIRFIGHTERS_PART401 from '@/components/KingofAirfighters_part401'
 import KINGOFAIRFIGHTERS_PART5 from '@/components/KingofAirfighters_part5'
 import KINGOFAIRFIGHTERS_PART501 from '@/components/KingofAirfighters_part501'
 import KINGOFAIRFIGHTERS_PART6 from '@/components/KingofAirfighters_part6'
 import KINGOFAIRFIGHTERS_PART601 from '@/components/KingofAirfighters_part601'
 import LOVE_2 from '@/components/love_2'
 import KINGOFAIRFIGHTERS_ACKNOWLEDGMENTS from '@/components/KingofAirfighters_acknowledgments'
 import KINGOFAIRFIGHTERS_FOOTNOTE from '@/components/KingofAirfighters_footnote'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/KingofAirfighters_frontcover",
 			"name" : "KingofAirfighters_frontcover",
 			"component" : KINGOFAIRFIGHTERS_FRONTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/KingofAirfighters_title",
 			"name" : "KingofAirfighters_title",
 			"component" : KINGOFAIRFIGHTERS_TITLE
 		},
 		{
 			"path" : "/KingofAirfighters_copyright",
 			"name" : "KingofAirfighters_copyright",
 			"component" : KINGOFAIRFIGHTERS_COPYRIGHT
 		},
 		{
 			"path" : "/KingofAirfighters_toc",
 			"name" : "KingofAirfighters_toc",
 			"component" : KINGOFAIRFIGHTERS_TOC
 		},
 		{
 			"path" : "/KingofAirfighters_illustration",
 			"name" : "KingofAirfighters_illustration",
 			"component" : KINGOFAIRFIGHTERS_ILLUSTRATION
 		},
 		{
 			"path" : "/KingofAirfighters_dedication",
 			"name" : "KingofAirfighters_dedication",
 			"component" : KINGOFAIRFIGHTERS_DEDICATION
 		},
 		{
 			"path" : "/KingofAirfighters_preface",
 			"name" : "KingofAirfighters_preface",
 			"component" : KINGOFAIRFIGHTERS_PREFACE
 		},
 		{
 			"path" : "/KingofAirfighters_introduction",
 			"name" : "KingofAirfighters_introduction",
 			"component" : KINGOFAIRFIGHTERS_INTRODUCTION
 		},
 		{
 			"path" : "/KingofAirfighters_part1",
 			"name" : "KingofAirfighters_part1",
 			"component" : KINGOFAIRFIGHTERS_PART1
 		},
 		{
 			"path" : "/KingofAirfighters_part101",
 			"name" : "KingofAirfighters_part101",
 			"component" : KINGOFAIRFIGHTERS_PART101
 		},
 		{
 			"path" : "/KingofAirfighters_part2",
 			"name" : "KingofAirfighters_part2",
 			"component" : KINGOFAIRFIGHTERS_PART2
 		},
 		{
 			"path" : "/KingofAirfighters_part201",
 			"name" : "KingofAirfighters_part201",
 			"component" : KINGOFAIRFIGHTERS_PART201
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js